import type { ReviewPageQuery } from '../../__generated__/graphql';

export type ProfileVisibility2TypeNames = NonNullable<
  NonNullable<ReviewPageQuery['viewer']>['profileVisibility2']
>['__typename'];

export type ProfileVisibilityOption = {
  id: string;
  label: string;
  __typename: ProfileVisibility2TypeNames;
};

type ProfileVisibilitySectionState = {
  profileVisibilityLevelTypename?: ProfileVisibility2TypeNames;
};

// The logic for Profile Visibility Review (Warning + Toggle + Radio Selection)
export const getProfileVisibilityReview = ({
  profileVisibilityOptions,
  profilePrivacyId,
}: {
  profileVisibilityOptions: ProfileVisibilityOption[];
  profilePrivacyId?: string;
  selectedRadioProfilePrivacyId?: string;
}): ProfileVisibilitySectionState => {
  // Typename coming from the graph (used for which UI to show).
  const profileVisibilityLevelTypename = profileVisibilityOptions.find(
    (option) => option.id === profilePrivacyId,
  )?.__typename;

  return {
    profileVisibilityLevelTypename,
  };
};

export const shouldShowProfileVisibilityInline = (
  profileVisibilityLevelTypename: ProfileVisibility2TypeNames,
): boolean => {
  const isPublicProfile =
    profileVisibilityLevelTypename === 'PublicVisibilityOption';

  // For Public, don't show inline for any variation
  if (isPublicProfile) {
    return false;
  }

  // For All other variations, do not show inline
  return true;
};
